import styled from "styled-components";

export const Container = styled.div`
  padding: 2rem 3rem;
  @media (min-width: 425px) {
    padding: 2rem 5rem;
  }
  @media (min-width: 1024px) {
    padding: 2rem 7rem;
  }
  @media (min-width: 1440px) {
    padding: 2rem 9rem;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  .inputContent{
    margin: 2rem 0 0 2rem;
  }
`

export const Content = styled.div`
  background: ${({ theme }) => theme.colors.background};
  border-radius: 1rem;
  box-shadow: 5px 5px 5px #00000018;
  width: 100%;
  height: fit-content;
  padding: 2rem;

  .center{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

`